/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllLoans } from "../../redux/slices/loan/loanReportSlice";
import { fetchCustomers } from "../../redux/slices/Customer/customerReportSlice";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
import { toast } from "react-toastify";
import "./Agreement.css";

const LoanSanctionLetter = () => {


   const { loanId } = useParams();
  const dispatch = useDispatch();

  // ✅ Local user ID (for KYC photo)
  const createdById = Number(localStorage.getItem("userId")) || 0;

  // ✅ Redux states
  const { profile } = useSelector((state) => state.userProfile);

  // ✅ Local states
  const [loan, setLoan] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [company, setCompany] = useState(null);
  const [photoUrl, setPhotoUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  const [signatureUrl, setSignatureUrl] = useState(null);


    const [guarantor, setGuarantor] = useState(null);
  

  // ✅ Fetch user profile first
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
      const branchId = Number(localStorage.getItem("userId")) || 0;

    const loadData = async () => {
      try {
        setLoading(true);

        // ✅ Fetch all loans
        const loanAction = await dispatch(fetchAllLoans());
        const loanList = loanAction.payload?.data || loanAction.payload || [];
        const selectedLoan = loanList.find(
          (l) => String(l.id) === String(loanId)
        );

        if (!selectedLoan) {
          toast.error("Loan not found");
          setLoading(false);
          return;
        }

        setLoan(selectedLoan);

        // ✅ Fetch customer using new API
        if (selectedLoan?.customerId) {
          try {
            const res = await fetch(
              `https://narrowitsolution.in/api/customers-get-userId?userId=${selectedLoan.customerId}&branchId=${branchId}`
            );
            if (!res.ok) throw new Error("Failed to fetch customer details");
            const data = await res.json();
            const customerData = data.data || data;
            setCustomer(customerData);
          } catch (err) {
            console.error("Failed to fetch customer:", err);
            toast.error("Error fetching customer details");
          }
        }

        // ✅ Fetch company details dynamically
        if (profile?.superAdminId) {
          try {
            const res = await fetch(
              `https://narrowitsolution.in/api/get-company?superAdminId=${profile.superAdminId}`
            );
            if (!res.ok) throw new Error("Failed to fetch company info");
            const data = await res.json();
            const companyInfo = data.data || data;
            if (companyInfo.logo) {
              companyInfo.logoUrl = `https://narrowitsolution.in/${companyInfo.logo.replace(
                /^images\//,
                ""
              )}`;
            }
            setCompany(companyInfo);
          } catch (err) {
            console.error("Failed to fetch company details:", err);
          }
        }

        // ✅ Fetch customer KYC photo
        if (selectedLoan?.customerId && profile?.superAdminId) {
          try {
            const res = await fetch(
              `https://narrowitsolution.in/api/list-kyc?userId=${selectedLoan.customerId}&superAdminId=${profile.superAdminId}&createdById=${createdById}`
            );
            const data = await res.json();
            console.log("Kyc Data:", data.documents);
            if (res.ok && data.documents?.length > 0) {
              const photoDoc = data.documents.find(
                (doc) => doc.docName?.toLowerCase() === "photo"
              );
              const signDoc = data.documents.find(
                (doc) => doc.docName?.toLowerCase() === "signature"
              );
              if (photoDoc?.docImage) 
                setPhotoUrl(`https://narrowitsolution.in/uploads/${photoDoc.docImage}`);
              if (signDoc?.docImage)
                setSignatureUrl(`https://narrowitsolution.in/uploads/${signDoc.docImage}`);
              console.log("signature URL:",`https://narrowitsolution.in/uploads/${signDoc.docImage}`);
            }
          } catch (err) {
            console.error("Failed to fetch customer photo:", err);
          }
        }




        
        if (selectedLoan.customerId) {
  try {
    const url = `https://narrowitsolution.in/api/nominee-get-all?loanId=${loanId}&branchId=${branchId || 0}&customerId=${selectedLoan.customerId}`;
    const res = await fetch(url);
    const data = await res.json();

    if (res.ok && data.success && Array.isArray(data.data) && data.data.length > 0) {
      setGuarantor(data.data[0]); // pick first guarantor record for this loan
    } else {
      toast.warn(`No guarantor data found for loan: ${loanId}`, {
    toastId: `no-guarantor-${loanId}`,
  });
    }
  } catch (err) {
    console.error("Error fetching guarantor details:", err);
  }
}
      } catch (err) {
        console.error(err);
        toast.error("Error loading data");
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [dispatch, loanId, profile?.superAdminId, createdById]);

  if (loading) return <p>Loading data...</p>;
  if (!loan) return <p>No loan data found.</p>;

  // ✅ Customer and loan data
  const c = customer || {};
  const appliedDate = loan.loanAppliedDate
    ? new Date(loan.loanAppliedDate).toLocaleDateString("en-GB")
    : "-";

  // ✅ Company defaults
  const companyName = company?.name || "Techvision Company";
  const companyLogo = company?.logoUrl || "/logo.png";
  const companyCIN = company?.cin || "U88900AS2025NPL028600";
  const companyMobile = company?.contact || "0000000000";
  const companyEmail = company?.email || "xyz@gmail.com";
  const companyAddress =
    company?.address|| "House No-4, Ahiyapur, Muzaffarpur, Bihar - 781014";
  return (
    <div className="Agreement-letter-container">
      <div
        className="Agreementletter-header"
      >
        {/* Logo on the left */}
        <div className="Agreementlogo-box">
          <img
            src={companyLogo}
            alt="logo"
          />
        </div>

        {/* Company details aligned right vertically */}
        <div
        className="Agreementcompany-details"
        >
          {/* <h2
            style={{
              margin: 0,
              fontSize: "22px",
              fontWeight: "bold",
              color: "#2c3e50",
            }}
          >
            {companyName}
          </h2>
          <span style={{ fontSize: "13px", color: "#333" }}>
             <strong>CIN : </strong>{companyCIN}
          </span>
          <span style={{ fontSize: "13px", color: "#333" }}>
            <strong>Regt. Office : </strong> {companyAddress}
          </span>
          <span style={{ fontSize: "13px", color: "#333" }}>
            <strong>Mobile No : </strong> {companyMobile}
          </span>
          <span style={{ fontSize: "13px", color: "#333" }}>
            <strong>Email ID : </strong> {companyEmail}
          </span> */}
          <div><h2>{companyName}</h2></div>
          <div><span><strong>CIN:</strong> {companyCIN}</span></div>
          <div style={{textAlign:"center"}}><span><strong>Regt. Office:</strong> {companyAddress}</span></div>
          <div><span><strong>Mobile No:</strong> {companyMobile}</span></div>
          <div><span><strong>Email ID:</strong> {companyEmail}</span></div>
        </div>
      </div>

      <h3 className="Sanctitle">Loan Agreement Letter</h3>

      {/* Branch / Group */}
      <table className="Sancdetails-table">
        <tbody>
          <tr>
            <td>
              <strong>Branch : </strong> {profile?.branchName || "N/A"}
            </td>
              <td>
              <strong>Applied Date :</strong> {appliedDate}
            </td>
            
          </tr>
         
        </tbody>
      </table>

      {/* Customer Info */}
      <table className="Sancdetails-table">
        <tbody>
          <tr>
            <td className="field-name">Customer Name</td>
            <td className="field-value">{c.fullName || "N/A"}</td>

          <td className="field-name">C/O</td>
            <td className="field-value">{c.guardianName || "-"}</td>

            <td rowSpan="4" className="Sancphoto-box">
              <img
                src={photoUrl || "/user.png"}
                alt="customer"
                className="customer-photo"
                crossOrigin="anonymous"
              />
            </td>
          </tr>

          <tr>
            <td className="field-name">District</td>
            <td className="field-value">
              {c.district || "-"} - {c.state || "-"}
            </td>

            <td className="field-name">Contact Number</td>
            <td className="field-value">{c.mobileNumber || "-"}</td>
          </tr>

          <tr>
            <td className="field-name">Gender</td>
            <td className="field-value">{c.gender || "-"}</td>

            <td className="field-name">Date of Birth</td>
            <td className="field-value">
              {c.dateOfBirth
                ? new Date(c.dateOfBirth).toLocaleDateString("en-GB")
                : "-"}
            </td>
          </tr>

          {/* <tr>

              <td className="field-name">Address & Pincode</td>
            <td className="field-value address-column">
              {c.address || "-"} - {c.pincode || "-"}
            </td>
          

          </tr> */}
<tr className="full-address-row">
  <td className="field-name">Full Address</td>
  <td className="field-value" colSpan="4">
    {[
      c.address,
     
      c.pincode
    ]
      .filter(Boolean)
      .join(", ") || "-"}
  </td>
</tr>

          {/* <tr>
            <td className="field-name">Co-Applicant Address</td>
            <td className="field-value" colSpan="3">
              {c.coApplicantAddress || "-"}
            </td>
          </tr> */}
        </tbody>
      </table>

      {/* Bank Info */}
      {/* Bank Details Table */}
      <table className="Sanc-Bank-table">
        <tbody>
             <tr>
           
            <td className="field-name">Loan Amount</td>
            <td className="field-value">{loan.loanAmount || "-"}</td>
             
            <td className="field-name">Interest Type</td>
            <td className="field-value">{loan.loanRoiType || "-"}</td>
          </tr>
          {/* <tr>
            <td className="field-name">Bank</td>
            <td className="field-value">{c.bankName || "-"}</td>
            <td className="field-name">Bank Branch</td>
            <td className="field-value">{c.bankBranch || "-"}</td>
          </tr> */}
          <tr>
            <td className="field-name">Loan Account Number</td>
            <td className="field-value">{loan.loanAccountNumber || "-"}</td>
            <td className="field-name">Plan Name</td>
            <td className="field-value">{loan.loanService || "-"}</td>
          </tr>
          {/* <tr>
            <td className="field-name">Account Holder</td>
            <td className="field-value">{c.fullName || "-"}</td>
            <td className="field-name">Account Number</td>
            <td className="field-value">{c.bankAccount || "-"}</td>
          </tr> */}
          {/* <tr>
            <td className="field-name">IFSC</td>
            <td className="field-value">{c.bankIFSC || "-"}</td>
            <td className="field-name">Loan Amount</td>
            <td className="field-value">{loan.loanAmount || "-"}</td>
          </tr> */}
          <tr>
            <td className="field-name">Recovery Type</td>
            <td className="field-value">{loan.loanRecoveryFrequency || "-"}</td>
            <td className="field-name">Amount to be Paid</td>
            <td className="field-value">{loan.loanPayable || "-"}</td>
          </tr>
          <tr>
            <td className="field-name">No of Payment</td>
            <td className="field-value">{loan.loanTenure || "-"}</td>
            
            <td className="field-name">Interest Amount</td>
            <td className="field-value">{loan.loanInterest || "-"}</td>
          </tr>
          <tr>
            <td className="field-name">Purpose</td>
            <td className="field-value">{loan.loanPurpose || "-"}</td>
            <td className="field-name">Roi </td>
            <td className="field-value">{loan.loanRoi || "-"} %</td>
          
          </tr>
        </tbody>
      </table>

      {/* Guarantor & Nominee Table */}
         {/* Guarantor & Nominee Table */}
<table className="Sanc-Guarantor-tables">
  <tbody>
    <tr>
      <td className="field-name">Guarantor Name</td>
      <td className="field-value">{guarantor?.guarantorName || "-"}</td>

     <td className="field-name">Pan No</td>
      <td className="field-value">{guarantor?.panNumber || "-"}</td>


      <td rowSpan="4" className="Sanc-Guarantor-photo-box">
        <img
          src={
            guarantor?.guarantorImage
              ? `https://narrowitsolution.in/uploads/${guarantor.guarantorImage}`
              : "/user.png"
          }
          alt="guarantor"
          crossOrigin="anonymous"
        />
      </td>
    </tr>

   

   
    <tr>
      <td className="field-name">Relation</td>
      <td className="field-value">{guarantor?.relationApplicant || "-"}</td>

      <td className="field-name">Aadhaar No</td>
      <td className="field-value">{guarantor?.guarantorAadhar || "-"}</td>
    </tr>
     <tr>
      <td className="field-name">Contact Number</td>
      <td className="field-value">{guarantor?.guarantorMobile || "-"}</td>
      
    
    </tr>
  </tbody>
</table>


      {/* Signature */}
      <table className="Agreement-Signature-table">
        <tbody>
          <tr>
            <td>
          Member Signature <br /> (सदस्य के हस्ताक्षर)
          <div style={{ height: "80px" }}>
            {signatureUrl && signatureUrl.trim () !== "" ? (
              <img 
              src = {signatureUrl}
              alt = "Member Signature"
              className = "Agreement-Signature-img"
              style = {{ width: "160px", height: "50%", marginTop:"14px", marginLeft:"2rem",}}
              />
            ) :(
              <p className="Agreement-no-sign">No Signature Uploaded</p>
            )}
            </div> 
        </td>
        <td>
          Spouse Signature <br /> (जीवनसाथी के हस्ताक्षर)
          <div style={{ height: "80px" }}></div>
        </td>
      
        <td>
          Branch Seal With Signature <br /> (शाखा मोहर के साथ हस्ताक्षर)
          <div style={{ height: "80px" }}></div>
        </td>
          </tr>
        </tbody>
      </table>
      <div className="Agreement-rule-company-details">
        <h1>नियम और शर्तें</h1>
      </div>
      <br></br>
      <ol className="Agreement-rules-list">
        <li>
          उपरोक्त सभी पक्ष निम्नलिखित सभी शर्ते व नियम पर अपनी सहमति व्यक्त करते
          हैं यह है कि ऋण धारी इस राशि का उपयोग माइक्रोफाइनेंस की नियमावली समझकर
          करेंगे तथा इस राशि या इसके किसी भी अंश का उपयोग अन्य किसी भी उद्देश्य
          की पूर्ति हेतु नहीं करेंगे जिसके लिए इसे स्वीकृत नहीं किया गया है हम
          इसके लिए भी सहमति व्यक्त करते हैं कि यदि कंपनी को सबसे कोई कारण मिलता
          है जो स्पष्ट करता है कि सर्च की पालन नहीं की गई है तो कंपनी को अधिकार
          है कि वह इस ऋण राशि या उसके अंश को बिना किसी रियायत के वापस ले लेंगे ।
        </li>
        <li>
          मैं/हम लोन के लिए आवेदन करने वाले तथा गारंटर पूर्व में किसी भी गैर
          कानूनी कार्य में लिप्त नहीं है और ना ही किसी न्यायालय में हमारे
          विरुद्ध आपराधिक मामला विचाराधीन है और ना ही किसी भी थाने में कोई एफ आई
          आर दर्ज है।
        </li>
        <li>
          यह है कि मैं/हमें किसी वित्तीय संस्थान,बैंक या फाइनेंस कंपनी से
          मुझे/हमको डिफॉल्टर घोषित नहीं किया गया है।
        </li>
        <li>
          यह है कि मैं/हम उक्त लोन की संपूर्ण किस्तों का भुगतान करने में पूरी
          तरह से सक्षम है और किसी भी विपरीत परिस्थिति में मैं/हम भुगतान करने में
          देरी नहीं करेंगे।
        </li>
        <li>
          यह है कि कंपनी का जो भी कर्मचारी किस्त की राशि का कलेक्शन करने आएगा
          मैं उसके साथ विनम्र व्यवहार रखूंगा एवं उसे किसी भी प्रकार की आपत्तिजनक
          बात ना कहेंगे किसी भी प्रकार का उसको नुकसान या मारपीट की कोशिश नहीं
          करेंगे और ना ही उसके खिलाफ गंदे व्यवहार या अपशब्द बोलने आरोप नहीं
          लगाएंगे अगर हमारे द्वारा कोई भी अभद्र व्यवहार किया जाता है तो कंपनी
          कर्मचारी तथा कंपनी हमारे प्रति कानूनी कारवाई करने के लिए स्वतंत्र
          होंगे ।
        </li>
        <li>
          यह है कि मैं/हम नियत तिथि की सूचना देने से संबंधित जानकारी अपनी
          किस्तों के संपूर्ण भुगतान के लिए नोटिस रिमाइंडर व इलेक्ट्रॉनिक सूचना
          फोन इत्यादि करने के लिए कंपनी जिम्मेदारी नहीं होगी इस बात की याददाश्त
          संबंधित संपूर्ण जिम्मेदारी मेरी या हमारी होगी।
        </li>
        <li>
          यह है कि अगर ऋणी या गारंटर अपने व्यवसाय नौकरी मूल निवास मोबाइल नंबर या
          ईमेल आईडी का परिवर्तन करता है तो इस बात की सूचना कंपनी को पूर्व में
          लिखित प्रदान करेंगे।
        </li>
        <li>
          यह है कि मैं/हम यह वचनबद्ध बयान करते हैं कि भविष्य में यदि हमारे
          द्वारा किस्तों का भुगतान चेक के माध्यम से किया जाता है तो हम दिए गए
          चेको को बैंक में स्टॉप नहीं कराएंगे और ना ही उक्त चेक के खोने की
          रिपोर्ट दर्ज थाने में कराएंगे और ना ही उक्त खाते को बंद कर आयेंगे यदि
          हम ऐसा करते हैं तो कंपनी हमारे विरुद्ध कानूनी कारवाई करने का अधिकार
          रखेगी ।
        </li>
        
        <li>
          यह है कि इस अनुबंध के अनुसार गारंटर की पूरी जिम्मेदारी और उत्तरदायित्व
          है अगर भविष्य में आवेदक के साथ कोई आकस्मिक घटना मृत्यु या दिवालिया या
          गंभीर बीमारी हो जाती है तो संपूर्ण लोन का भुगतान गारंटर द्वारा किया
          जाएगा।
        </li>
        <li>
          यह है कि हम/मैं द्वारा कंपनी को दी गई संपूर्ण जानकारी मौखिक प्रदान की
          गई है जो कि सत्य व सही है जिसमें किसी भी प्रकार का कोई भी झूठा तथ्य
          नहीं बताया गया है यदि कोई जानकारी झूठी पाई जाती है तो कंपनी हमारे
          विरोध कानूनी कारवाई करने का अधिकार रखेगी मैं/हम ने लोन के बारे में
          समस्त जानकारी जैसे ब्याज तथा किस्तों की राशि किस्तों का समय और अदायगी
          का समय अच्छी तरह से समझ लिया है कंपनी कर्मचारी द्वारा मुझे संपूर्ण
          जानकारी दे दी गई है उक्त सभी नियमों व शर्तों के लिए मैं/हम पूरी तरह
          तैयार है और अगर मैं/हम किस्त देने में देरी करते हैं तो उस पर लगने वाला
          अतिरिक्त भार लीगल खर्चा पेपर खर्चा विजिट खर्चा व अन्य खर्च जो भी
          भविष्य में आएगा वह हमारे द्वारा प्रदान किया जाएगा।
        </li>
        <li>
          यह है कि मैं/हम प्रस्तुत किए गए समस्त दस्तावेज जैसे कि आधार कार्ड पैन
          कार्ड राशन कार्ड ड्राइविंग लाइसेंस बैंक की पासबुक व फोटो के साथ किसी
          भी तरह की छेड़छाड़ या कोई भी फर्जी दस्तावेज हमारे द्वारा प्रस्तुत नहीं
          किया गया है निकट भविष्य में अगर किसी भी दस्तावेज के फर्जी पाए जाने पर
          हमारे खिलाफ 420 ई का मुकदमा कंपनी द्वारा किया जा सकता है इस बात से हम
          पहले से जानकार हैं।
        </li>
        <li>
          यह है कि हम/मैं अपनी किस्तों का भुगतान
          दैनिक/साप्ताहिक/द्विसाप्ताहिक/मासिक रूप में करना चाहता हूं।
        </li>
        <li>
          यह है कि इस ऋण के भुगतान और उसके बकाया या किसी भी अंश की स्वीकृति या
          किसी भी अन्य विशिष्ट कार्य हेतु जब भी कंपनी द्वारा बुलाया जाएगा मैं/हम
          समय पर उपस्थित हो जाएंगे।
        </li>
        <li>
          यह है कि मेरी सालाना आय रु 300000 से कम है उक्त एग्रीमेंट या लोन को
          करते समय हमने किसी भी प्रकार का कोई नशा नहीं किया हुआ है हम पूरे होशो
          हवास में यह एग्रीमेंट कर रहे हैं।
        </li>
        <li>
          हम यह वचन बद्ध बयान करते है की भविष्य में यदि हमारे द्वारा किस्त समय
          पर नहीं जमा होगी तो कंपनी हमारे विरुद्ध कानूनी कार्यवाही करने का
          अधिकार रखेगी।इससे मुझे कोई आपत्ति नहीं है।
        </li>
        <li>
          हम अगर अपनी किस्त समय से नहीं जमा करते है या डिफॉल्ट होने की स्थिति
          में कंपनी सिबिल पर हमारा रिकॉर्ड दर्ज करने का अधिकार रखेगी।{" "}
        </li>
      </ol>
  <table className="Agreement-Signature-table">
        <tbody>
          <tr>
            <td>
          Member Signature <br /> (सदस्य के हस्ताक्षर)
          <div style={{ height: "75px" }}>
            
            {signatureUrl && signatureUrl.trim () !== "" ? (
              <img
              src = {signatureUrl}
              alt = "Member Signature"
              className= "Agreement-Signature-img"
              style = {{ width: "160px", height: "50%", marginTop:"14px", marginLeft:"2rem",}}
              />
            ) : (
              <p className="Agreement-no-sign">No Signature Uploaded</p>
            )}
            </div> 
          
        </td>
        <td>
          Spouse Signature <br /> (जीवनसाथी के हस्ताक्षर)
          <div style={{ height: "75px" }}></div>
        </td>
      
        <td>
          Branch Seal With Signature <br /> (शाखा मोहर के साथ हस्ताक्षर)
          <div style={{ height: "75px" }}></div>
        </td>
          </tr>
        </tbody>
      </table>
      <div className="Agreement-rule-company-details">
        <h1>Terms and Condition</h1>
      </div>
      <br></br>
      <ol className="Agreement-rules-list">
        <li>
          All the above parties agree to all the following terms and conditions:
          The borrower will use this amount as per the rules of microfinance and
          will not use any amount or any part of it for any other purpose. We
          also agree that if the company finds any reason to explain which has
          not been complied with, the company has the right to withdraw this
          loan amount or part thereof without any notice. We will withdraw the
          concession.
        </li>
        <li>
          I and my guarantor are not involved in any illegal act in the past,
          and neither a criminal case is pending against us in any court nor is
          any First Information Report (FIR) registered in any police station.
        </li>
        <li>
          I/We are not burdened with any kind of loan from any financial
          institution, bank, or finance company, nor have I/we been declared a
          defaulter by any financial institution, bank, or finance company.
        </li>
        <li>
          I/We are fully capable of paying the entire installments of the said
          loan and I/We shall not delay the payment under any circumstances.
        </li>
        <li>
          That whichever employee of the company comes to collect the
          installment amount, I will keep polite behavior with them and will not
          call them any kind of objectionable thing. I will not try to harm or
          beat them in any way nor will I be dirty against him. Will not allege
          behaviour or abusive language. If any abusive behaviour is done by us
          then the company will be free to take legal action against us.
        </li>
        <li>
          I/We and the company will not be responsible for giving notices,
          reminders and electronic information, etc. For the full payment of my
          installments related to information of the date of payment of the
          loan, the entire responsibility related to this will be mine/ours.
        </li>
        <li>
          That if the borrower(s) or the guarantor(s) change their business,
          job, residence, mobile number or email ID, they shall give prior
          written notice to the company.
        </li>
        <li>
          That I/We undertake to make a statement that if the installments are
          paid by us in future through are paid by us in future through cheque,
          then we will not make stop payment of the cheques given in the bank
          nor report the loss of the said cheque to the police station. Nor will
          we close that account. If we do so, the company will have the right to
          take legal action against us.
        </li>
        <li>
          This is during the Company’s storage related facilities such as
          S.M.S., we will provide the additional service charge required for
          providing the calling, email notice.
        </li>
       
        <li>
          That all the information given by us to the company has been provided
          correctly, which is true and correct, in which no false fact of any
          kind has been told. If any information is found to be false then the
          company has the right to take legal action against us. I will keep all
          the information about the loan, such as the amount of interest,
          installment, the time of installment and the time of repayment. I have
          been given complete information by the company employee. We are fully
          prepared for all the above terms and conditions and if we delay in
          paying the installment, then the additional burden of legal expenses
          and other expenses which will come in future will be provided by us.
        </li>
        <li>
          That all the documents submitted by me/us such as Aadhar card, pan
          card, ration card, driving license, bank passbook and photo have not
          been tampered with and are not forged. If any documents are found to
          be forged, we can be sued for 420 by the company, which we are aware
          of beforehand.
        </li>
        <li>
          That I/we want to pay our installments daily/weekly/bi-weekly/monthly
          (as per agreed upon).
        </li>
        <li>
          That I/we shall be present in time as and when called by the company
          for the payment of this loan and acceptance of the arrears or for any
          other specified purpose.
        </li>
        <li>
          That my annual income is less than ₹3,00,000. I/we have not done any
          kind of intoxication while doing this agreement or loan, and I/we are
          doing this agreement in full consciousness.
        </li>
        <li>
          I/We undertake that in the future, if I/we do not deposit the
          installments on time, the company will have the right to take legal
          action against me/us. I/we have no objection to this.
        </li>
        <li>
          If we do not deposit our installments on time or in case of default, the company reserves the right to register our records on CIBIL.

        </li>
      </ol>
      {/* Signature */}
       <table className="Agreement-Signature-table">
        <tbody>
          <tr>
            <td>
          Member Signature <br /> (सदस्य के हस्ताक्षर)
          <div style={{ height: "75px" }}>
            
            {signatureUrl && signatureUrl.trim () !== "" ? (
              <img
              src = {signatureUrl}
              alt = "Member Signature"
              className = "Agreement-Signature-img"
              style = {{ width: "160px", height: "50%", marginTop:"14px", marginLeft:"2rem",}}
              />
            ) :(
              <p className="Agreement-no-sign">No Signature Uploaded</p>
            )}

            </div> 
        </td>
        <td>
          Spouse Signature <br /> (जीवनसाथी के हस्ताक्षर)
          <div style={{ height: "75px" }}></div>
        </td>
      
        <td>
          Branch Seal With Signature <br /> (शाखा मोहर के साथ हस्ताक्षर)
          <div style={{ height: "75px" }}></div>
        </td>
          </tr>
        </tbody>
      </table>
      <div className="loan-application-print-button">
        <button onClick={() => window.print()}>Print</button>
      </div>
    </div>
  );
};

export default LoanSanctionLetter;



